import React, { FC } from 'react';
import { RadioButtonProps } from './modules';
import { RadioButtonStyled } from './styles';

/**
 * A custom radio button component that can be used to select a single option from a list of options.
 *
 * @param props - The properties for the radio button, as defined by the RadioButtonProps interface.
 */
const RadioButton: FC<RadioButtonProps> = ({
  id,
  label,
  checked,
  onChange,
  subLabel,
  disabled,
}) => {
  return (
    <RadioButtonStyled disabled={disabled}>
      <input
        id={id}
        type="radio"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id}>
        {label}
        <span> {subLabel}</span>
      </label>
    </RadioButtonStyled>
  );
};

export default RadioButton;
